import React, { useState, useEffect, useRef, Fragment } from 'react';
import Layout from './Layout';
import HitCard from './HitCard';
import { getCategories, getFilteredProducts, getFilteredProductsExceptUser } from './apiCore';
import { getActiveTrades } from '../user/apiUser';
import { isAuthenticated } from '../auth';
import Checkbox from './Checkbox';
import RadioBox from './RadioBox';
import { prices } from './FixedPrices';
import MainMenu from './Menu';
import algoliasearch from 'algoliasearch';
import {
    InstantSearch,
    Hits,
    connectSearchBox,
    Pagination,
    RefinementList,
    connectRefinementList,
    RangeSlider,
    Configure,
    connectInfiniteHits,
} from 'react-instantsearch-dom';
import { Dialog, Disclosure, Menu, Popover, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/solid';
import { ChevronDownIcon } from '@heroicons/react/solid';
import CustomPriceRefinement from './CustomPriceRefinement';

const sortOptions = [
    { name: 'Most Popular', href:'#', current:false },
    { name: 'Best Rating', href:'#', current: false },
    { name: 'Newest', href: '#', current: false },
];
const filters = [
  {
    id: 'category',
    name: 'Category',
  },
  {
    id: 'brand',
    name: 'Brand',
  },
  {
    id: 'size',
    name: 'Size',
  },
  {
    id: 'price',
    name: 'Price',
  }
]

const classNames = (...classes) => {
    return classes.filter(Boolean).join(' ');
};

const activeFilters = [{ value: 'objects', label: 'Objects' }]

const appId = 'O616IHS8SQ';
const apiKey = '1a61d9059fcc3f918576c7aa95279846';
const searchClient = algoliasearch(appId, apiKey);

const Listings = () => {
    const [myFilters, setMyFilters] = useState({
        filters: { category: [], price: [] }
    });
    const [categories, setCategories] = useState([])
    const [error, setError] = useState(false);
    const [limit, setLimit] = useState(6);
    const [skip, setSkip] = useState(0);
    const [size, setSize] = useState(0);
    const [filteredResults, setFilteredResults] = useState([]);
    const [open, setOpen] = useState(false);

    const [activeTrades, setActiveTrades] = useState([]);
    const activeTradesRef = useRef();
    activeTradesRef.current = activeTrades;

    const loadMore = () => {
        let toSkip = skip + limit;

        getFilteredProducts(toSkip, limit, myFilters.filters).then( data => {
            if (data.error) {
                setError(data.error);
            }
            else {
                setFilteredResults([...filteredResults, ...data.data]);
                setSize(data.size)
                setSkip(toSkip);
            }
        });
    };

    const loadMoreButton = () => {
        return (
            size > 0 && size >= limit && (
                <button onClick={loadMore}className='btn btn-warning mb-5'> Load More </button>
            )
        );
    };

    const loadFilteredResults = (newFilters) => {
        if (isAuthenticated()) {
            const {user: {_id}} = isAuthenticated();
            console.log(_id);
            getFilteredProductsExceptUser(_id, skip, limit, myFilters.filters).then(data => {
                if (data.error) {
                    setError(data.error);
                }
                else {
                    setFilteredResults(data.data);
                    setSize(data.size)
                    setSkip(0);
                }
            });
        }
        else {
            getFilteredProducts(skip, limit, newFilters).then( data => {
                if (data.error) {
                    setError(data.error);
                }
                else {
                    setFilteredResults(data.data);
                    setSize(data.size)
                    setSkip(0);
                }
            });
        }
    };
 
    //load categories and set form data
    const init = () => {
        if (isAuthenticated()) {
            const { user: {_id}, token } = isAuthenticated();
            getActiveTrades(_id, token).then(data => {
                if (data.error) {
                    console.log('error getting user active trades');
                }
                else {
                    setActiveTrades(data);
                }
            });
        }

        getCategories().then(data => {
            if (data.error) {
                setError(data.error);
            }
            else {
                setCategories(data);
            }
        });
    };

    useEffect(() => {
        loadFilteredResults(skip, limit, myFilters.filters);
        init();
    }, []);
    
    
    const ShowRefinement = ({type}) => {
        if (type === 'Category') {
            return (
                <CustomCategoryRefinement attribute='category'/>
            );
        }
        else if (type === 'Brand') {
            return (
                <CustomBrandRefinement attribute='brand'/>
            );
        }
        else if (type === 'Size') {
            return (
                <CustomSizeRefinement attribute='size'/>
            );
        }
        else if (type === 'Price') {
            return (
                <div className='w-64'>
                    <CustomPriceRefinement attribute='price' min={0} max={2000}/>
                </div>
            );
        };
    };
    //might use currentRefinement is useState to show current filters 
    const CategoryRefinement = ({ items, currentRefinement, refine }) => (
	  <div>
		<form>
		  {items.map((item,i) => (
             <div key={item.label} className='flex items-center'>
                 <input
                     id={i}
                     name={i}
                     type='checkbox'
                     value={item.isRefined}
                     className='h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500'
                     onChange={event => {
                         refine(item.value)
                     }}
                 />

                 <label
                     htmlFor={i}
                     className='ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap'
                 >
                     {item.label}
                 </label>
             </div>
		  ))}
		</form>
	  </div>
    );
    const CustomCategoryRefinement = connectRefinementList(CategoryRefinement);

    const SizeRefinement = ({ items, refine}) => (
	  <div>
		<form>
		  {items.map((item,i) => (
             <div key={item.label} className='flex items-center'>
                 <input
                     id={i}
                     name={i}
                     type='checkbox'
                     value={item.isRefined}
                     className='h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500'
                     onChange={event => {
                         refine(item.value)
                     }}
                 />

                 <label
                     htmlFor={i}
                     className='ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap'
                 >
                     {item.label}
                 </label>
             </div>
		  ))}
		</form>
	  </div>
    );
    const CustomSizeRefinement = connectRefinementList(SizeRefinement)

    const BrandRefinement = ({ items, refine, searchForItems }) => (
        <div>
            <input
                type='search'
                placeholder='Search for brands'
                onChange={event => searchForItems(event.currentTarget.value)}
                className='rounded-md'
            />

                {items.map((item, i) => (
                    <div key={i} className='flex items-center'>
                        <input
                            id={i}
                            name={i}
                            type='checkbox'
                            value={item.isRefined}
                            className='h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500'
                            onChange={event => {
                                refine(item.value);
                            }}
                        />
                        <label
                            htmlFor={i}
                            className='ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap'
                        >
                            {item.label}
                        </label>
                    </div>
                ))}
        </div>
    );
    const CustomBrandRefinement = connectRefinementList(BrandRefinement);
    

    const Filters = () => (
    <div className="bg-white pt-3">
      {/* Mobile filter dialog */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 flex z-40 sm:hidden" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <div className="ml-auto relative max-w-xs w-full h-full bg-white shadow-xl py-4 pb-12 flex flex-col overflow-y-auto">
              <div className="px-4 flex items-center justify-between">
                <h2 className="text-lg font-medium text-gray-900">Filters</h2>
                <button
                  type="button"
                  className="-mr-2 w-10 h-10 bg-white p-2 rounded-md flex items-center justify-center text-gray-400"
                  onClick={() => setOpen(false)}
                >
                  <span className="sr-only">Close menu</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>

              {/* Filters */}
              <form className="mt-4">
                {filters.map((section) => (
                  <Disclosure as="div" key={section.name} className="border-t border-gray-200 px-4 py-6">
                    {({ open }) => (
                      <>
                        <h3 className="-mx-2 -my-3 flow-root">
                          <Disclosure.Button className="px-2 py-3 bg-white w-full flex items-center justify-between text-sm text-gray-400">
                            <span className="font-medium text-gray-900">{section.name}</span>
                            <span className="ml-6 flex items-center">
                              <ChevronDownIcon
                                className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-5 w-5 transform')}
                                aria-hidden="true"
                              />
                            </span>
                          </Disclosure.Button>
                        </h3>
                        <Disclosure.Panel className="pt-6">
                            <ShowRefinement type={section.name}/>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                ))}
              </form>
            </div>
          </Transition.Child>
        </Dialog>
      </Transition.Root>

      {/* Filters */}
      <section aria-labelledby="filter-heading">
        <h2 id="filter-heading" className="sr-only">
          Filters
        </h2>

        <div className="relative z-10 bg-white border-b border-gray-200 pb-4">
          <div className="max-w-7xl mx-auto px-4 flex items-center justify-between sm:px-6 lg:px-8">
            <Menu as="div" className="relative inline-block text-left">
              <div>
                  {/*
                <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                  Sort
                  <ChevronDownIcon
                    className="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                </Menu.Button>
                */}

                <h1 className="text-2xl font-extrabold tracking-tight text-gray-900">Trade and Sell Shoes, Clothes & Hats</h1>


              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="origin-top-left absolute left-0 mt-2 w-40 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {sortOptions.map((option) => (
                      <Menu.Item key={option.name}>
                        {({ active }) => (
                          <a
                            href={option.href}
                            className={classNames(
                              option.current ? 'font-medium text-gray-900' : 'text-gray-500',
                              active ? 'bg-gray-100' : '',
                              'block px-4 py-2 text-sm'
                            )}
                          >
                            {option.name}
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>

            <button
              type="button"
              className="inline-block text-sm font-medium text-gray-700 hover:text-gray-900 sm:hidden"
              onClick={() => setOpen(true)}
            >
              Filters
            </button>

            <div className="hidden sm:block">
              <div className="flow-root">
                <Popover.Group className="-mx-4 flex items-center divide-x divide-gray-200">
                  {filters.map((section, sectionIdx) => (
                    <Popover key={section.name} className="px-4 relative inline-block text-left">
                      <Popover.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                        <span>{section.name}</span>
                        <ChevronDownIcon
                          className="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                          aria-hidden="true"
                        />
                      </Popover.Button>

                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Popover.Panel className="origin-top-right absolute right-0 mt-2 bg-white rounded-md shadow-2xl p-4 ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <ShowRefinement type={section.name}/>
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  ))}
                </Popover.Group>
              </div>
            </div>
          </div>
        </div>

        {/* Active filters */}

      </section>
    </div>
    );



    const CustomHits = connectInfiniteHits(({hits, hasPrevious, refinePrevious, hasMore, refineNext}) => {
        return (
            <div className='max-w-7xl mx-auto px-4 sm:py-8 sm:px-6 lg:max-w-7xl lg:px-8'>
                <div className='grid grid-cols-2 gap-x-2 sm:grid-cols-3 sm:gap-x-4 sm:gap-y-10 lg:grid-cols-4 lg:gap-x-8'>
                    {hits.map(hit => (
                        <HitCard key={hit.objectID} hit={hit} activeTrades={activeTradesRef.current}/>
                    ))}
                </div>
                
                <div className='py-5'>
                <button
                    disabled={!hasMore}
                    onClick={refineNext}
                    style={{display: hasMore ? '' : 'none'}}
                    type="button"
                    className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Load More
                </button>
                </div>
            </div>
        )
    });

    const SearchBox = ({ currentRefinement, isSearchStalled, refine}) => (
    <form noValidate action='' role='search'>
        <div className="mt-1 relative flex items-center pl-3 pr-3 w-full">
        <input
          type="search"
          name="search"
          value={currentRefinement}a
            onChange={event => refine(event.currentTarget.value)}
          id="search"
            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-400 block shrink p-2 sm:text-sm border-gray-300 rounded-md border-2 lg:w-96"
        />
        <div className="absolute inset-y-0 right-0 flex py-1.5 pr-3">
          <kbd className="inline-flex items-center border border-gray-200 rounded p-2 text-sm font-sans font-medium text-gray-400">
            ⌘K
          </kbd>
        </div>
      </div>
    </form>

    );
    const CustomSearchBox = connectSearchBox(SearchBox);

    return (
        <div id='ais-InstantSearch'>
            <InstantSearch
                indexName='dev_lootswap'
                searchClient={searchClient}>
                <MainMenu>
                    <CustomSearchBox/>
                </MainMenu>
                <div>
                    <div>
                       
                        <Filters/>
                        <Configure hitsPerPage={10} />
                    </div>
                    
                    <div>
                        <CustomHits className='hits ais-Hits-list'/>
                    </div>
                </div>
            </InstantSearch>
        </div>
    );
};

export default Listings;
